import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
interface CountdownClockProps {
  tone?: 'dark' | 'light';
}
const START = 23 * 3600 + 59 * 60 + 1;
export function CountdownClock({
  tone = 'dark'
}: CountdownClockProps) {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown(START);
  const units = [{
    value: hours,
    label: 'Hours'
  }, {
    value: minutes,
    label: 'Min'
  }, {
    value: seconds,
    label: 'Sec'
  }];
  const box = tone === 'dark' ? 'bg-espresso text-cream' : 'bg-cream text-espresso border border-espresso/10';
  return <div className="flex items-center justify-center gap-2 sm:gap-3" role="timer" data-id="element-58" data-mp="1wyy73zbjve6b">
      {units.map((unit, index) => <React.Fragment key={unit.label} data-id="element-59" data-mp="1o0cqi9pn2986" data-mpi={index}>
          <div className={`flex min-w-[72px] flex-col items-center rounded-xl px-4 py-3 sm:min-w-[88px] ${box}`} data-id="element-60" data-mp="1o1e70tpfbnxa">
            <span className="font-display text-3xl font-semibold tabular-nums leading-none sm:text-4xl" data-id="element-61" data-mp="3ddq2ml3zt1ju">
              {unit.value}
            </span>
            <span className="mt-1.5 font-sans text-[10px] font-bold uppercase tracking-[0.18em] opacity-70" data-id="element-62" data-mp="nrlpf0deymy0">
              {unit.label}
            </span>
          </div>
          {index < units.length - 1 ? <span className={`font-display text-2xl ${tone === 'dark' ? 'text-espresso/40' : 'text-cream/40'}`} aria-hidden="true" data-id="element-63" data-mp="wkfhxzhvfitt">
              :
            </span> : null}
        </React.Fragment>)}
    </div>;
}